import { dateToString } from '../util/dates';

import React, { type MutableRefObject } from 'react';
import classNames from 'classnames';
import * as dateFns from 'date-fns';
import scss from './DayLabel.module.scss';
import { useFormatter } from '../hooks/useLang';

function DayLabel({
  date,
  currentDate,
  daysMap,
  daysMapInverse,
}: {
  date: Date;
  currentDate: Date;
  daysMap?: WeakMap<HTMLDivElement, Date>;
  daysMapInverse?: MutableRefObject<Record<string, HTMLDivElement>>;
}) {
  const formatter = useFormatter();
  const isCurrentDate = dateFns.isSameDay(date, currentDate);
  const dayKey = dateToString(date);

  return (
    <div
      className={classNames(scss.comp, {
        [scss.currentDate ?? '']: isCurrentDate,
      })}
      ref={(elem) => {
        if (elem) {
          daysMap?.set(elem, date);
          if (daysMapInverse) {
            daysMapInverse.current[dayKey] = elem;
          }
        }
      }}
    >
      {formatter.weekdayDayMonthCap(date)}
    </div>
  );
}

export default DayLabel;
